import React from 'react';
import { PropTypes } from 'prop-types';
// state
import { useSelector } from 'react-redux';
import { selectors as uiSelectors } from 'state/ui';
// style
import styled, { css } from 'styled-components';
import { expandHeightAndWidth } from 'utils/style';
// components
import AppBar from 'refactored/ui/nav/appBar';
import MainMenu from 'refactored/ui/nav/mainMenu/MainMenu';
import PageWithFeedback from 'refactored/ui/layout/PageWithFeedback';

const AuthenticatedUserView = ({ className, children, handleBack }) => {
  const isMainMenuOpened = useSelector(uiSelectors.isMainMenuOpened);

  return (
    <div className={className}>
      <AppBar handleBack={handleBack} />
      <MainMenu isMainMenuOpened={isMainMenuOpened} handleBack={handleBack} />
      <PageWithFeedback isMainMenuOpened={isMainMenuOpened}>
        {children}
      </PageWithFeedback>
    </div>
  );
};

AuthenticatedUserView.propTypes = {
  handleBack: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};

const regularCSS = css`
  display: flex;
  flex-direction: column;
  ${expandHeightAndWidth}

  @media print {
    overflow: auto;
    display: block !important;
    position: static !important;
  }
`;

const StyledAuthenticatedUserView = styled(AuthenticatedUserView)`
  ${regularCSS};
`;

export default StyledAuthenticatedUserView;
